// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__lry7T","bigColWidth":"Table_bigColWidth__nCHOx","biggerColWidth":"Table_biggerColWidth__oc4sq","row":"Table_row__MPpKR","col":"Table_col__2Q6Wm"};